import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export const AdminLayout = () => {
	const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

	return (
		<div className="min-h-screen bg-white">
			<Sidebar collapsed={sidebarCollapsed} />
			<Topbar
				sidebarCollapsed={sidebarCollapsed}
				onMenuClick={() => setSidebarCollapsed(!sidebarCollapsed)}
			/>
			<main
				className={`min-h-screen pt-16 transition-all duration-300 ease-in-out ${
					sidebarCollapsed ? "ml-[70px]" : "ml-[250px]"
				}`}
			>
				<div className="px-8 py-8">
					<Outlet />
				</div>
			</main>
		</div>
	);
};
